import React from "react";
import "./GridStyles.scss";

const Grid = ({ children, columns = 3 }) => {
  return <div className={`people-grid people-grid--cols${columns}`}>{children}</div>;
};

export default Grid;
